import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Fragment } from 'react';
import { dateFormmater } from '../../../helpers';

export const ViewConditionWork = ({ data }) => {

    const { firstDate, lastDate, iva, paymentMethod, date, dateCall } = data;
    return (
        <TableContainer component='div' >
            <Table sx={{ minWidth: 650 }} size='small' aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {
                            (firstDate && lastDate)
                                ?
                                <Fragment>
                                    <TableCell align='center'><b>Fecha de inicio</b></TableCell>
                                    <TableCell align="center"><b>Fecha de fin</b></TableCell>
                                </Fragment>
                                :
                                <Fragment>
                                    <TableCell align='center'><b>Fecha del presupuesto</b></TableCell>
                                    <TableCell align="center"><b>Llamar el</b></TableCell>
                                </Fragment>
                        }
                        <TableCell align="center"><b>IVA</b></TableCell>
                        <TableCell align='center'><b>Forma de pago</b></TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow >
                        {
                            (firstDate && lastDate) ?
                            <Fragment>
                                <TableCell align='center'>{dateFormmater(firstDate)}</TableCell>
                                <TableCell align="center">{dateFormmater(lastDate)}</TableCell>
                            </Fragment>
                            :
                            <Fragment>
                                <TableCell align='center'>{dateFormmater(date)}</TableCell>
                                <TableCell align="center">{dateFormmater(dateCall)}</TableCell>
                            </Fragment>
                        }
                        <TableCell align="center">{iva}</TableCell>
                        <TableCell align='center'>{paymentMethod}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

            // <Stack >
            //     <Typography variant='subtitle1'><b>Fecha estimada de inicio:</b> {dateFormmater(firstDate)}</Typography>
            //     <Typography variant='subtitle1'><b>IVA:</b> {iva}</Typography>
            // </Stack>
            // <Stack >
            //     <Typography variant='subtitle1'><b>Fecha estimada de fin:</b> {dateFormmater(lastDate)}</Typography>
            //     <Typography variant='subtitle1'><b>Forma de pago:</b> {paymentMethod}</Typography>
            // </Stack>
